import { createApiSlice } from "@common";
import { CRUD_NOTICE_PERIOD } from "@routes";

const apiConfig = [
  {
    name: "addNoticePeriod",
    method: "post",
    url: CRUD_NOTICE_PERIOD,
    stateKey: "message"
  },
  
  {
    name: "getNoticePeriod",
    method: "get",
    url: CRUD_NOTICE_PERIOD,
    stateKey: "data"
  },
  {
    name: "updateNoticePeriod",
    method: "put",
    url: CRUD_NOTICE_PERIOD,
    stateKey: "message"
  },
  {
    name: "deleteNoticePeriod",
    method: "delete",
    url: CRUD_NOTICE_PERIOD,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: []
  },
  reducers: {
    setAdditionalData: (state, action) => { state.additionalData = action.payload; },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "NoticePeriod",
  apiConfig,
  customReducers
);
const NoticePeriodSlice = slice;

export default NoticePeriodSlice.reducer;

export const {
  addNoticePeriod,
  getNoticePeriod,
 
  updateNoticePeriod,
  deleteNoticePeriod
} = thunks;
export const { rowSelect } = actions;
